import React from 'react';
import withIcon from '../utilities/withIcon';

const IconInfo = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm.775 5.16.007.104v4.034l.26-.289a.753.753 0 0 1 .969-.128l.088.067a.74.74 0 0 1 .129.962l-.068.088-1.567 1.748c-.434.483-1.22.22-1.302-.39l-.007-.105v-4.03l-.225.25a.753.753 0 0 1-.97.13l-.087-.068a.74.74 0 0 1-.13-.961l.067-.088 1.534-1.713c.434-.484 1.22-.222 1.302.388zM8.033 2.5c.38 0 .693.28.742.642l.007.101v1.045c0 .41-.335.744-.749.744a.747.747 0 0 1-.742-.643l-.007-.1V3.242c0-.41.335-.743.75-.743z" />
    </g>
  );
};

export default withIcon(IconInfo);
